import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import type { FocusEventHandler, ReactNode } from 'react';
type DocumentPaneProps = {
  id: string;
  eyebrow?: string;
  title: ReactNode;
  subtitle?: string;
  actions?: ReactNode;
  contentClassName?: string;
  children: ReactNode;
  onBlur?: FocusEventHandler<HTMLDivElement>;
};
const DocumentPane = t0 => {
  const $ = _c(25);
  const {
    id,
    eyebrow,
    title,
    subtitle,
    actions,
    contentClassName: t1,
    children,
    onBlur
  } = t0;
  const contentClassName = t1 === undefined ? "gap-4" : t1;
  let t2;
  if ($[0] !== eyebrow) {
    t2 = eyebrow && <p className="mb-1.5 text-label-3 text-tertiary">{eyebrow}</p>;
    $[0] = eyebrow;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== subtitle) {
    t3 = subtitle && <p className="mt-1 text-body-2 text-tertiary">{subtitle}</p>;
    $[2] = subtitle;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3 || $[6] !== title) {
    t4 = <div className="min-w-0 flex-1">{t2}{title}{t3}</div>;
    $[4] = t2;
    $[5] = t3;
    $[6] = title;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== actions || $[9] !== eyebrow) {
    t5 = actions && <div className={cx("flex shrink-0 items-center gap-1", eyebrow && "mt-6")}>{actions}</div>;
    $[8] = actions;
    $[9] = eyebrow;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div className="flex items-start gap-3">{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = subtitle ? "mt-8" : "mt-6";
  let t8;
  if ($[14] !== contentClassName || $[15] !== t7) {
    t8 = cx("flex flex-col", t7, contentClassName);
    $[14] = contentClassName;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== children || $[18] !== t8) {
    t9 = <div className={t8}>{children}</div>;
    $[17] = children;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== id || $[21] !== onBlur || $[22] !== t6 || $[23] !== t9) {
    t10 = <div data-id={id} onBlur={onBlur} className="group/pane">{t6}{t9}</div>;
    $[20] = id;
    $[21] = onBlur;
    $[22] = t6;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
};
export { DocumentPane };